import React from 'react';
import { connect } from 'react-redux';
import {
  LocalForm,
  Form,
  Control,
  actions
} from 'react-redux-form';
import { capitalize } from '../helpers'
import shortid from 'shortid';
import swal from 'sweetalert'
import SortableConditions from './SortableConditions'
// import {arrayMove} from 'array-move';

import {
  scripts_index,
  create_script,
  destroy_script,
  update_script,
  batch_update_entries
} from '../actions'

import FiltersUpdate from './FiltersUpdate'
import FiltersUpdateForm from './FiltersUpdateForm'
const { toast, Datepicker, FormSelect, Tooltip } = window.M

const mapStateToProps = state => {
  return {
    form: state.forms.setFilters,
    filters: state.entry.filters,
    scripts: state.script.items,
    master_id: state.entry.master_id
  };
}

const { M } = window

const mapDispatchToProps = dispatch => {
  return {
    // addColumns: (report_id, column_string, before) => dispatch( add_columns(report_id, column_string, before) ),
    resetForm: () => dispatch( actions.reset('setFilters') ),
    setValue: (field, value) => dispatch( actions.change(field, value) ),
    createScript: (account_id, values) => dispatch( create_script(account_id, values) ),
    updateScript: (account_id, script_id, values) => dispatch( update_script(account_id, script_id, values) ),
    deleteScript: (account_id, script_id) => dispatch( destroy_script(account_id, script_id) ),
    getScripts: (account_id) => dispatch( scripts_index(account_id) ),
    // batchUpdate: (report_id, filters, operations, dry) => dispatch( batch_update_entries(report_id, filters, operations, dry) )
    batchUpdate: (report_id, filters, conditions, dry) => dispatch( batch_update_entries(report_id, filters, conditions, dry) )

  };
}

class ConnectedFiltersForm extends React.Component {
  constructor () {
    super()
    this.state = {
      fieldSelector: null,
      operatorSelector: null,
      dateSelector: null,
      scriptsSelector: null,
      currentRule: null,
      dateLimits: {
        created_at: {
          dateMax: new Date(),
          dateMin: null,
        },
        updated_at: {
          dateMax: new Date(),
          dateMin: null,
        }
      },
      localFilters: [],
      localOperations: [],
      currentType: "string",
      currentArray: false,
      currentOperator: '',
      inputVisible: true,

      conditions: [],
      current_condition: { filters: [], operations: [] },
      initial_condition: { filters: [], operations: [] },

      showRules: null // "form" "select"
    }
  }

  array_move = (arr, old_index, new_index) => {
      if (new_index >= arr.length) {
          var k = new_index - arr.length + 1;
          while (k--) {
              arr.push(undefined);
          }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
      return arr; // for testing
  }

  reArrange = (from, to) => {
    this.setState({
      conditions: this.array_move(this.state.conditions, from, to)
    })
  }

  batchUpdate(dry=false) {
    const { report_id } = this.props
    const { localFilters, localOperations, conditions } = this.state
    // this.props.batchUpdate(report_id, localFilters, localOperations, dry)
    this.props.batchUpdate(report_id, localFilters, conditions, dry)
  }

  resetForm() {
    this.props.resetForm()
    setTimeout(function(self) {
      const { fieldSelector, operatorSelector } = self.state
      fieldSelector.destroy()
      operatorSelector.destroy()

      const fieldsElelment = document.getElementById('fieldsSelector')
      const newFieldsSelector = FormSelect.init(fieldsElelment);
      self.setState({fieldSelector: newFieldsSelector})

      const operatorsElement = document.getElementById('operatorsSelector')
      // operatorsElement.value = "="
      const newOperatorsSelector = FormSelect.init(operatorsElement);
      self.setState({operatorSelector: newOperatorsSelector})
    }, 100, this)
    this.setState({
      currentType: "string",
      inputVisible: true
    })
  }

  hide() {
    this.props.hide()
    this.resetFilters()
  }

  resetFilters() {
    this.setState({
      localOperations: [],
      localFilters: [...this.props.filters],
      conditions: [this.state.initial_condition],
      current_condition: this.state.initial_condition,
      currentRule: null,
      showRules: null
    })
    this.resetForm()
    this.formDispatch( actions.change('scripts.script', '') )
    this.formDispatch( actions.reset('scripts') )
    document.querySelector('#scriptsSelector').value = ''
    this.resetScripts()
  }

  getFiltered(inFilters) {
    const filters = inFilters ? inFilters : this.state.localFilters
    this.props.resetCollapsible()
    this.props.getFiltered(filters)
  }

  componentDidUpdate(prevProps, prevState) {
    const {columns, scripts} = this.props
    const prevcolumns = prevProps.columns
    const prevscripts = prevProps.scripts
    if ( JSON.stringify(columns) !== JSON.stringify(prevcolumns) ) {
      const fs = this.state.fieldSelector
      fs.destroy()
      const fieldsElement = document.getElementById('fieldsSelector')
      const fieldsSelector = FormSelect.init(fieldsElement);
      this.setState({fieldSelector: fieldsSelector})
    }
    if ( JSON.stringify(scripts) !== JSON.stringify(prevscripts) ) {
      this.resetScripts()
    }
  }

  resetScripts() {
    const fs = this.state.scriptsSelector
    fs.destroy()
    const scriptsElement = document.getElementById('scriptsSelector')
    const scriptsSelector = FormSelect.init(scriptsElement);
    this.setState({scriptsSelector: scriptsSelector})
  }

  componentDidMount() {
    const fieldsElelment = document.getElementById('fieldsSelector')
    const fieldsSelector = FormSelect.init(fieldsElelment);
    this.setState({fieldSelector: fieldsSelector})

    const operatorsElelment = document.getElementById('operatorsSelector')
    const operatorsSelector = FormSelect.init(operatorsElelment);
    this.setState({operatorSelector: operatorsSelector})

    const initial_condition = {
      operations: [],
      id: shortid.generate(),
      filters: this.props.filters
    }
    this.setState({
      localFilters: this.props.filters,
      initial_condition: initial_condition,
      current_condition: initial_condition,
      conditions: [initial_condition]
    })

    const scriptsElement = document.getElementById('scriptsSelector')
    const scriptsSelector = FormSelect.init(scriptsElement);
    this.setState({scriptsSelector: scriptsSelector})

    const el = document.getElementById('patternHelp')
    Tooltip.init(el, {
      html:
        `<div class="patternDiv">
          <div class="patternDivHead">Examples</div>
          <div>[ab]: Pattern contains letter "a" or letter "b"</div>
          <div>cc[ab]cc: Pattern contains "ccacc" or "ccbcc"</div>
          <div>[^ab]: Pattern does not contains letters "a" and "b"</div>
          <div>(aa|bb): Pattern contains "aa" or "bb"</div>
          <div>ab: Pattern contains "ab"</div>
          <div>\\bab\\b: Pattern contains word "ab"</div>
          <div>\\Aab: Pattern begins with "ab"</div>
          <div>ab\\z: Pattern ends with "ab"</div>
          <div>\\d+: Pattern contains one or more numerical digits</div>
        </div>`
    })

    const { account_id } = this.props
    if (account_id !== undefined && account_id !== null && account_id !== '') {
      this.props.getScripts(account_id)
    }
  }

  setCurrentType(event) {
    const field = event.target.value

    // const number_fields=["price", "sale_price", "title_length", "boost"]
    const boolean_fields=["newentry", "removed", "published"]
    const date_fields=["created_at", "updated_at"]

    const { currentType, operatorSelector } = this.state
    let is_date = false
    const { setValue } = this.props
    let changed = false

    // if ( number_fields.indexOf(field) > -1 ) {
    if ( field.match(/_length$/) ) {
      if ( currentType !== "number" ) {
        changed = true
      }
      this.setState({
        currentType: "number",
        inputVisible: true
      })

    } else if ( boolean_fields.indexOf(field) > -1 ) {
      if ( currentType !== "boolean" ) {
        changed = true
      }
      this.setState({
        currentType: "boolean",
        inputVisible: false
      })
      setValue("setFilters.operator", "true")
      this.setState({ inputVisible: false })

    } else if ( date_fields.indexOf(field) > -1 ) {
      is_date = true
      if ( currentType !== "date" ) {
        changed = true
      }
      this.setState({
        currentType: "date",
        inputVisible: true
      })
      setValue("setFilters.operator", "<= ")
      this.setState({ inputVisible: true })

    } else { // string
      if ( currentType !== "string" ) {
        changed = true
      }
      this.setState({
        currentType: "string",
        inputVisible: true
      })
    }

    if ( is_date ) {
      setTimeout( (self) => {
        const elem = document.getElementById('filterValue')
        let dateMax, dateMin
        if ( field === "updated_at") {
          dateMax = self.state.dateLimits.updated_at.dateMax
          dateMin = self.state.dateLimits.updated_at.dateMin
        } else {
          dateMax = self.state.dateLimits.created_at.dateMax
          dateMin = self.state.dateLimits.created_at.dateMin
        }
        const dp = Datepicker.init(elem, {
          container: 'body',
          maxDate: dateMax,
          minDate: dateMin,
          onClose: () => {
           if (dp.date !== null && dp.date !== undefined) {
             setValue("setFilters.value", dp.date)
             elem.value = dp.date.toLocaleDateString()
           }
          }
        })
        self.setState( {
          dateSelector: dp
         } )
      }, 100, this)
    } else {
      if ( this.state.dateSelector !== null) {
        this.state.dateSelector.destroy()
      }
      this.setState( { dateSelector: null } )
    }

    if (changed) {
      setTimeout(function(self) {
        operatorSelector.destroy()
        const operatorsElement = document.getElementById('operatorsSelector')
        const operatorsSelector = FormSelect.init(operatorsElement);
        self.setState({operatorSelector: operatorsSelector})
      }, 100, this)
    }
  }

  setArrayType(event) {
    const field = event.target.value
    const arrayTypes = ["in", "notin"]
    const inputHidden = ["~", "!~", "true", "false", "off", "on"]
    if ( arrayTypes.indexOf(field) < 0 ) {
      this.setState({ currentArray: false })
    } else {
      this.setState({ currentArray: true })
    }

    if ( inputHidden.indexOf(field) < 0 ) {
      this.setState({ inputVisible: true })
    } else {
      this.setState({ inputVisible: false })
    }

    this.setState( { currentOperation: field } )

  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch
  }

  handleNewRule(values) {
    const {script, global, ...other} = values
    const {localFilters, localOperations, conditions} = this.state
    const localConditions = conditions.filter( c => c.filters.length > 0 )
    // if (!localFilters || localFilters.length === 0 ) {
    //   return toast({html: "There are no filters selected"})
    // } else {
    if (localConditions.length === 0) {
      return toast({html: "There are no filters"})
    } else {

      const globalValue = (global === true)
      const { report_id, account_id } = this.props
      const { currentRule } = this.state
      const newValues = {
        ...other,
        global: globalValue,
        report_id: report_id,
        conditions: conditions
        // filters: localFilters,
        // operations: localOperations,
        // current_condition: {
        //   ...this.state.current_condition,
        //   filters: localFilters,
        //   operations: localOperations
        // }
      }

      if (this.state.currentRule !== null) {
        this.props.updateScript( account_id, currentRule, newValues )
      } else {
        this.props.createScript( account_id, newValues )
      }
    }
  }

  handlePickRule(e) {
    const { value } = e.target
    const script = this.props.scripts.find( s => s.id === value )
    if (script !== undefined) {
      const { columns } = this.props
      const columnNames = columns.map( c => c.key )
      this.formDispatch( actions.change('scripts.name', script.name) )
      this.formDispatch( actions.change('scripts.description', script.description || '') )
      this.formDispatch( actions.change('scripts.global', script.global ) )
      const current_condition = {
        id: shortid.generate(),
        filters: [],
        operations: []
      }
      this.setState({
        // localFilters: script.script.filters.filter( f => columnNames.indexOf(f.field) > -1 ),
        // localOperations: script.script.operations.filter( f => columnNames.indexOf(f.field) > -1 && ( f.append === "" || f.append === undefined || f.append === null || columnNames.indexOf(f.append) > -1) ),
        currentRule: script.id,
        conditions: [
          ...script.conditions,
          current_condition
        ],
        current_condition: current_condition,
        localFilters: [],
        localOperations: [],
        showRules: 'form'
      })
      setTimeout( function() {
        M.updateTextFields()
      }, 150)
    } else {
      this.formDispatch(actions.reset('scripts'))
      this.setState({
        currentRule: null,
      })
    }
  }

  handleDeleteRule() {
    swal({
      title: "Delete Rule",
      text: `Do you want to delete current rule?`,
      icon: "error",
      buttons: [true, true]
    }).then( willDelete => {
      if (willDelete) {
        const { currentRule } = this.state
        const { account_id, deleteScript } = this.props
        deleteScript(account_id, currentRule)
        this.setState({currentRule: null})
        this.formDispatch(actions.reset('scripts'))
      }
    })
  }

  handleSubmit(values) {
    const { localFilters, currentType , dateLimits } = this.state
    const { created_at, updated_at } = dateLimits
    const allowed = {
      "off": ["<", "<=", "!="],
      "on": ["!=", ">", ">="],
      ">=": ["<", "<=", "!=", "on"],
      ">": ["<", "<=", "!=", "on"],
      "<=": [">", ">=", "!=", "off"],
      "<": [">", ">=", "!=", "off"],
      "!=": ["<", "<=", ">", ">=", "off", "on"]
    }

    // if ( currentType !== "number" ) {
    if ( currentType === "string" ) {
      // 1. check for duplicates
      // Do not allow combine with equality
      const findOne = localFilters.filter( (filter) => {
        return (filter.field === values.field &&
          (
            filter.operator === '=' || values.operator === '=' ||
            filter.operator === '~' || values.operator === '~'
          )
        )
      })
      if (findOne.length > 0) {
        toast({
          html: "`Equals` and `Is empty` filters cannot be combined with other filters"
        })
        return
      }
    } else if ( currentType === 'boolean') {
      // 2. check for duplicates
      // Do not allow more than one for boolean
      const findOne = localFilters.filter( (filter) => {
        return (filter.field === values.field)
      })
      if (findOne.length > 0) {
        toast({
          html: "Please choose either true OR false"
        })
        return
      }
    } else {
      // 3. check if number and operators match
      const currentSet = allowed[values.operator]
      const findOne = localFilters.filter( (filter) => {
        const fieldExists = ( filter.field === values.field )
        const operationAllowed = ( typeof(currentSet) !== "undefined" && filter.operation !== values.operator) // compatible operations exist and operation has not already existed
        const currentOperationAllowed = operationAllowed && ( currentSet.indexOf(filter.operator) !== -1 )
        let value_allowed = true
        if ( currentOperationAllowed ) {
          if ( fieldExists  &&  [">", ">="].indexOf(values.operator) > -1 && filter.value && values.value && values.value >= filter.value) {
            value_allowed = false
          }
          if ( fieldExists  &&  ["<", "<="].indexOf(values.operator) > -1 && filter.value && values.value && values.value <= filter.value) {
            value_allowed = false
          }
        } else {
          value_allowed = false
        }

        return ( fieldExists && !value_allowed )
      })
      if (findOne.length > 0) {
        toast({
          html: "This filter conflicts with another filter for this column"
        })
        return
      }
      this.resetForm()
    }

    const allowed_empty = ["true","false","~","!~", "off", "on"]
    if ( allowed_empty.indexOf(values.operator) < 0 && ( typeof(values.value) === "undefined" || values.value === null || ( !(values.value instanceof Date) && values.value.trim() === "" ) ) ) {
      toast({
        html: "You must provide a value for this filter"
      })
      return
    } else if ( allowed_empty.indexOf(values.operator) < 0 && currentType === "number" ) {
      if (!( values.value > 0 || values.value === 0 )) {
        toast({
          html: "You must provide a positive numeric value for this filter"
        })
        return
      }
    }

    const short_id = shortid.generate();
    if ( currentType === "date" ) {
      if (values.operator === ">= ") {
        this.setState({
          dateLimits: {
            created_at: (values.field === "updated_at") ? {...created_at} : {
              ...created_at,
              dateMin: values.value
            },
            updated_at: (values.field === "created_at") ? {...updated_at} : {
              ...updated_at,
              dateMin: values.value
            }
          }
        })
      }
      if (values.operator === "<= ") {
        this.setState({
          dateLimits: {
            created_at: (values.field === "updated_at") ? {...created_at} : {
              ...created_at,
              dateMax: values.value
            },
            updated_at: (values.field === "created_at") ? {...updated_at} : {
              ...updated_at,
              dateMax: values.value
            }
          }
        })
      }
    }
    const prevFilters = this.state.conditions.find( c => c.id === this.state.current_condition.id)
    const add_filter = {
      key: short_id,
      ...values
    }
    const new_filters = prevFilters ? [
      ...prevFilters.filters,
      add_filter
    ] : [add_filter]
    const conditions = this.state.conditions.map( condition => {
      if ( this.state.current_condition.id !== undefined && condition.id === this.state.current_condition.id ) {
        return {
          ...condition,
          filters: new_filters
        }
      } else {
        return condition
      }
    })
    this.setState({
      localFilters: new_filters,
      current_condition: {
        ...this.state.current_condition,
        filters: new_filters
      },
      conditions: conditions
    })
    this.resetForm()
  }

  addOperation(operation) {
    const short_id = shortid.generate();
    const prevOperations = this.state.conditions.find( c => c.id === this.state.current_condition.id)
    const add_operation = {
      key: short_id,
      ...operation
    }

    const new_operations = prevOperations ? [
      ...prevOperations.operations,
      add_operation
    ] : [add_operation]

    const conditions = this.state.conditions.map( condition => {
      if (this.state.current_condition.id !== undefined && condition.id === this.state.current_condition.id) {
        return {
          ...condition,
          operations: new_operations
        }
      } else {
        return condition
      }
    })

    this.setState({
      localOperations: new_operations,
      current_condition: {
        ...this.state.current_condition,
        operations: new_operations,
      },
      conditions: conditions
    })
  }

  addCondition() {
    if ( this.state.conditions.length === 0 || (this.state.current_condition.filters.length >0 && this.state.current_condition.operations.length >0) ) {
      const short_id = shortid.generate();

      const new_condition = {
        id: short_id,
        filters: [],
        operations: []
      }
      this.setState({
        conditions: [
          ...this.state.conditions,
          new_condition
        ],
        current_condition: new_condition,
        localFilters: [],
        localOperations: []
      })
    }
  }

  removeOperation(condition_id, key) {
    const new_conditions = this.state.conditions.map( condition => {
      if (condition.id === condition_id) {
        return {
          id: condition.id,
          filters: condition.filters,
          operations: condition.operations.filter( o => o.key !== key)
        }
      } else {
        return condition
      }
    })

    this.setState({
      conditions: new_conditions,
    })
    this.setCurrentConditon(condition_id, new_conditions)
  }

  removeFilter(condition_id, key) {
    const new_conditions = this.state.conditions.map( condition => {
      if (condition.id === condition_id) {
        return {
          ...condition,
          filters: condition.filters.filter( c => c.key !== key)
        }
      } else {
        return condition
      }
    })
    this.setState({
      conditions: new_conditions
    })
    this.setCurrentConditon(condition_id, new_conditions)
  }

  removeCondition(id){
    const new_conditions = this.state.conditions.filter(c => c.id !== id)
    this.setCurrentConditon(null, new_conditions)
  }

  setCurrentConditon(id, conditions) {
    let new_conditions
    if ( conditions ) {
      new_conditions = conditions.filter( c => c.operations.length > 0 || c.filters.length > 0 )
    } else (
      new_conditions = this.state.conditions.filter( c => c.operations.length > 0 || c.filters.length > 0 )
    )
    if (new_conditions.length > 0) {
      const current_condition = new_conditions.find(c => c.id === id) || {
        id: shortid.generate(),
        operations:[],
        filters:[]
      }
      this.setState({
        current_condition: current_condition,
        conditions: new_conditions,
        localOperations: current_condition.operations,
        localFilters: current_condition.filters
      })
    } else {
      const blank_condition = {
        id: shortid.generate(),
        filters: [],
        operations: []
      }
      this.setState({
        current_condition: blank_condition,
        conditions: [blank_condition],
        localFilters: [],
        localOperations: []
      })
    }
  }

  render() {
    const operators={
      equals: "=",
      is_off_limits: "off",
      is_within_limits: "on",
      is_not_equal_to: "!=",
      contains: "like",
      does_not_contain: "notlike",
      is_greater_than: ">",
      is_less_than: "<",
      is_greater_than_or_equals: ">=",
      is_less_than_or_equals: "<=",
      is_any_of_values: "in",
      is_none_of_values: "notin",
      is_empty: "~",
      is_not_empty: "!~",
      is_true: "true",
      is_false: "false",
      is_before: "<= ",
      is_after: ">= "
    }

    const valid_operators={
      "string": [
        "equals", "is_not_equal_to", "contains", "does_not_contain",
        "is_any_of_values", "is_none_of_values", "is_empty", "is_not_empty"
      ],
      "number": [
        "equals", "is_off_limits", "is_within_limits", "is_not_equal_to", "is_any_of_values",
        "is_none_of_values", "is_greater_than", "is_greater_than_or_equals",
        "is_less_than", "is_less_than_or_equals", "is_empty", "is_not_empty"
      ],
      "date": [ "is_before", "is_after" ],
      "boolean": ["is_true", "is_false"]
    }

    // const required_input_types = ["=", "!=", "like", "<", ">", "<=", ">=", "in", "notin"]

    const {localFilters, currentType, currentArray, inputVisible, currentOperation, conditions, current_condition} = this.state

    const {isHidden, columns, scripts, hasUpdate} = this.props

    const displayOperators = valid_operators[currentType]

    const showPatternHint = ( ["like", "in", "notin"].indexOf(currentOperation) > -1 ) ? true : false

    const patternHintClass = showPatternHint ? 'col l2 xl2' : 'hide'

    const inputLabel = (currentArray) ? "e.g: value1,/pattern1/,value2" : ( (currentType === "date" ) ? "Select Date" : (currentOperation === "like" ? "Pattern" : "Value" ) )

    const applyButton = (localFilters.length > 0) ? "Apply Filters" : "No filters"

    const display = isHidden ? 'none' : 'inline'

    if ( columns.length === 0 ) {
      return ''
    }

    return (
      <React.Fragment>

        <div className={isHidden ? 'hide' : 'row'}>

          <div className="col s4 l4 xl4 z-depth-2 pad10 h350 mr-10" style={{textAlign: 'right'}}>
            <div>
              <Form
                model="setFilters"
                className={isHidden ? 'hide' : ''}
                style={{display: display}}
                onSubmit = { (values) => {
                  this.handleSubmit(values)
                }}
              >
                <div className="input-field">
                  <label htmlFor="fieldsSelector" className="active">Select Column to Filter</label>
                  <Control.select id="fieldsSelector" model= "setFilters.field" onChange={(e) => {
                    this.setCurrentType(e)
                  }}>
                    {
                      columns.filter(c => c.key !== "status").map( (column, index) => {
                        return(
                          <option value={column.key} key={index}>{column.name}</option>
                        )
                      })
                    }
                  </Control.select>
                </div>

                <div className="input-field">
                  <label htmlFor="operatorsSelector" className="active">Operator</label>
                  <Control.select id="operatorsSelector" model= "setFilters.operator" onChange={(e)=>{
                    this.setArrayType(e)
                  }}>
                    {
                      displayOperators.map( (operator, index) => {
                        return(
                          <option value={operators[operator]} key={index}>{capitalize(operator)}</option>
                        )
                      })
                    }
                  </Control.select>
                </div>

                <div className={"input-field" + ((inputVisible) ? "" : " hide")}>
                  <label htmlFor="filterValue">{ inputLabel }</label>
                  <Control.text id="filterValue" model="setFilters.value" />
                </div>

                <div className="row pa295">
                  <div className="col l9 xl9">
                    <button type="submit" className="btn red darken-1 waves-effect waves-light pull-right"><i className="material-icons right">navigate_next</i>Add </button>
                  </div>
                  <div className={ patternHintClass } style={{marginTop: "7px", height: "10px"}}>
                    <i id="patternHelp" className="material-icons c-red">help_outline</i>
                  </div>
                </div>

              </Form>
            </div>
          </div>

          {
            (localFilters.length > -1) && (
              <FiltersUpdateForm
                columns={columns}
                addOperation={this.addOperation.bind(this)}
                operations={this.state.localOperations}
                hide={this.hide.bind(this)}
                disabled={current_condition.filters.length < 1}
              />
            )
          }

          <div className="col s3 l3 xl3 pad10 h350">
            <div className="pa270" style={{width: '100%', margin: 0}}>

              <a href="" className="btn red darken-1 waves-effect waves-light pull-right" style={{width: 'calc(100% - 30px)'}} onClick={(e)=>{
                e.preventDefault()
                this.addCondition()
              }} disabled={this.state.conditions.filter( c => c.filters.length === 0 || c.operations.length === 0 ).length > 0}><i className="material-icons right">add</i>New Condition</a>

            </div>

            <div className="pa315" style={{width: '100%'}}>

              <a href="" className="btn red darken-1 waves-effect waves-light mr-10 " style={{width: 'calc(50% - 20px)', minWidth: 'auto'}} onClick={(e)=>{
                e.preventDefault()
                this.hide()
              }}>Cancel</a>

              <a href="" className="btn red darken-1 waves-effect waves-light mr-10 " style={{width: 'calc(50% - 21px)', minWidth: 'auto'}} onClick={(e)=>{
                e.preventDefault()
                this.resetFilters()
              }}>Clear All</a>

            </div>
          </div>
        </div>


        <SortableConditions
          conditions={conditions}
          isHidden={isHidden}
          operators={operators}
          valid_operators={valid_operators}
          removeFilter={this.removeFilter.bind(this)}
          removeOperation={this.removeOperation.bind(this)}
          batchUpdate={this.batchUpdate.bind(this)}
          hasUpdate={hasUpdate}
          report_id={this.props.report_id}
          reArrange={this.reArrange.bind(this)}
          removeCondition={this.removeCondition.bind(this)}
          current_condition={this.state.current_condition}
          getFiltered={this.getFiltered.bind(this)}
          setCurrentConditon={this.setCurrentConditon.bind(this)}
        />


        <LocalForm
          model="scripts"
          onSubmit={this.handleNewRule.bind(this)}
          getDispatch={dispatch => this.attachDispatch(dispatch)}
          style={{
            minWidth: 'auto'
          }}
        >
          <div style={{
            borderTop: "1px solid #ddd",
            paddingTop: 50,
          }} className={!hasUpdate ? 'hide' : 'row scriptFlex'}>
            <a className={this.state.showRules === null ? "btn waves-effect waves-light mr-10" : 'hide'} onClick={e=>{
              e.preventDefault()
              this.setState({showRules: 'select'})
            }}>
              <i className="material-icons right">navigate_next</i>Load Rule
            </a>
            <a className={this.state.showRules !== null ? "btn waves-effect waves-light mr-10" : 'hide'}  onClick={e=>{
              e.preventDefault()
              this.resetFilters()
            }}>
              Clear
            </a>
            <a className={this.state.showRules === null ? "btn waves-effect waves-light mr-10" : 'hide'} onClick={e=>{
              e.preventDefault()
              this.setState({
                showRules: 'form',
                currentRule: null
              })
            }}>
              <i className="material-icons right">navigate_next</i>New Rule
            </a>
          </div>

          <div className={ ( hasUpdate && this.state.showRules === 'select' ) ? 'row scriptFlex' : 'hide' }>
            <div className="s2 xl2">
              <div className="input-field scriptselector">
                <label htmlFor="scriptsSelector" className="active" style={{
                  top: -6
                }}>Select Existing Rule</label>
                <Control.select id="scriptsSelector" model="scripts.script" onChange={this.handlePickRule.bind(this)} defaultValue={""}>
                  <option value="">Select Rule</option>
                  {
                    scripts.filter( s => (s.global === true || s.report_id === this.props.master_id) ).map( s => {
                      return (
                        <option key={s.id} value={s.id}>{s.name}</option>
                      )
                    })
                  }
                </Control.select>
              </div>
            </div>
          </div>

          <div id="scriptForm" className={ ( hasUpdate && this.state.showRules === 'form' ) ? 'row scriptFlex' : 'hide' } >

            <div className="col s2 xl2 mr-10">
              <div className="input-field">
                <label htmlFor="scriptsName" className="active">Name</label>
                <Control.text id="scriptsName" model="scripts.name" required />
              </div>
            </div>
            <div className="col s5 xl5 mr-10">
              <div className="input-field">
                <label htmlFor="scriptsDescription" className="active">Description</label>
                <Control.text id="scriptsDescription" model="scripts.description"  />
              </div>
            </div>
            <div className="col s2 xl2 mr-10">
              <div className="switch">
                <label htmlFor="scriptsGlobal">
                  Use on all projects
                  <Control.checkbox id="scriptsGlobal" model="scripts.global"/>
                  <span className="lever"></span>
                </label>
              </div>
            </div>
            <div className="col s2 xl2">
              <button type="submit" className="btn waves-effect waves-light pull-right">
                <i className="material-icons right">navigate_next</i>{ this.state.currentRule === null ? 'Save' : 'Update'} Rule
              </button>
            </div>
            <div className="col s1 xl1" style={{paddingTop: 6}}>
              {
                (this.state.currentRule !== null) && (
                  <a href='' onClick={e=> {
                    e.preventDefault()
                    this.handleDeleteRule()
                  }}>
                    <i className="material-icons c-red" title="Remove Rule">cancel</i>
                  </a>
                )
              }

            </div>
          </div>
        </LocalForm>

      </React.Fragment>
    )
  }
}

const FiltersForm = connect(mapStateToProps, mapDispatchToProps)(ConnectedFiltersForm)
export default FiltersForm



// WEBPACK FOOTER //
// ./src/js/components/FiltersForm.js